<template>
  <div class="__wrapper">
    <div class="__head"></div>
    <div class="__body">
      <div class="__container">
        <div class="__content">
          <div class="__section-left">
            <!--                        <div class="__section-1">-->
            <!--                            <img :src="$fullUrl('images/profiles/'+getMeProfile.user.profile_picture)">-->
            <!--                            <span class="__green" style="cursor: pointer" @click="uploadPhoto">Change profile Image</span>-->
            <!--                            <input type="file" v-show="false" ref="photo">-->
            <!--                        </div>-->
            <div class="__section-2">
              <label>General infos</label>
              <!--                            <img src="../assets/icons/up.svg" style="margin-left: 10px;cursor: pointer" v-show="infoCollapsed" @click="infoCollapsed=!infoCollapsed">-->
              <!--                            <img src="../assets/icons/down.svg" style="margin-left: 10px;cursor: pointer" v-show="!infoCollapsed" @click="infoCollapsed=!infoCollapsed">-->
              <div class="__rows" v-show="infoCollapsed">
                <div class="__row">
                  <div class="__input">
                    <span>First Name</span>
                    <input type="text" v-model="getMeProfile.user.first_name" placeholder="Enter your First Name"
                      class="__inp-text" />
                  </div>
                  <div class="__input">
                    <span>Last Name</span>
                    <input type="text" v-model="getMeProfile.user.last_name" placeholder="Enter your Last Name"
                      class="__inp-text" />
                  </div>
                </div>
                <div class="__row">
                  <div class="__input">
                    <span>Telephone</span>
                    <input type="text" v-model="getMeProfile.profile.phone" placeholder="Enter your phone number"
                      class="__inp-text" />
                  </div>
                  <div class="__input">
                    <span>Email</span>
                    <input type="email" v-model="getMeProfile.user.email" placeholder="Enter your email"
                      class="__inp-text" />
                  </div>
                </div>
                <div class="__row">
                  <div class="__input">
                    <span>Country</span>
                    <select class="__inp-text" v-model="location.country" @change="loadCities">
                      <option></option>
                      <option v-for="(country, index) in getCountries.countries" :value="country.id">{{ country.name |
                        validate }}</option>
                    </select>
                  </div>
                  <div class="__input">
                    <span>City</span>
                    <select class="__inp-text" v-model="location.city">
                      <option></option>
                      <option v-for="(city, index) in getCities" :value="city.id">{{ city.name | validate }}</option>
                    </select>
                  </div>
                </div>
                <div class="__row-3">
                  <div class="__input">
                    <span>Are you available ?</span>
                    <select class="__inp-text" v-model="getMeProfile.profile.availability">
                      <option :value="1">Yes, i'm available</option>
                      <option :value="0">No, i'm not</option>
                    </select>
                  </div>
                  <div class="__input">
                    <span>When are you available from?</span>
                    <datepicker :monday-first="true" placeholder="From" :disabled-dates="{ to: new Date() }"
                      v-model="getMeProfile.profile.available_from" input-class="__inp-text" wrapper-class="__inp-text"
                      name="newproject_from_date"></datepicker>
                  </div>
                  <div class="__input">
                    <span>When are you available until?</span>
                    <datepicker :monday-first="true" placeholder="until" v-model="getMeProfile.profile.available_until"
                      input-class="__inp-text" wrapper-class="__inp-text" name="newproject_from_date"></datepicker>
                  </div>
                </div>
                <div class="__row-1">
                  <div class="__input">
                    <span>About</span>
                    <br />
                    <textarea class="__inp-text" style="background-image: none;width: 100%;height: 50px"
                      v-model="getMeProfile.profile.description" placeholder="Describe your self in person"></textarea>
                  </div>
                </div>
                <div style="width: 50%;display: flex;margin-top: 20px">
                  <div
                    style="border-radius:5px;padding:10px;color: #FFF;background: #1885AD;text-align: center;cursor: pointer"
                    @click="saveChanges">Save Changes</div>
                  <div style="padding: 10px;color: #1890A9;text-align: center;cursor: pointer" @click="discardChanges">
                    Cancel</div>
                </div>
              </div>
            </div>
            <div class="__section-2" style="padding-bottom: 50px">
              <label>Security infos</label>
              <img src="../assets/icons/up.svg" style="margin-left: 10px;cursor: pointer" v-show="passwordCollapsed"
                @click="passwordCollapsed = !passwordCollapsed" />
              <img src="../assets/icons/down.svg" style="margin-left: 10px;cursor: pointer" v-show="!passwordCollapsed"
                @click="passwordCollapsed = !passwordCollapsed" />
              <div class="__rows" v-show="passwordCollapsed">
                <div class="__row">
                  <div class="__input">
                    <span>Old Password</span>
                    <input type="password" placeholder="Enter your old Password" class="__inp-text"
                      v-model="oldPassword" />
                  </div>
                </div>
                <div class="__row">
                  <div class="__input">
                    <span>New Password</span>
                    <input type="password" placeholder="Enter your New Password" class="__inp-text"
                      v-model="newPassword" />
                  </div>
                </div>
                <div class="__row">
                  <div class="__input">
                    <span>Confirm Password</span>
                    <input type="password" placeholder="Confirm your New Password" class="__inp-text"
                      v-model="newPassword2" />
                  </div>
                </div>
                <div style="width: 30%;display: flex;justify-content: space-between;margin-top: 20px">
                  <div
                    style="border-radius:5px;padding: 10px;color: #FFF;background: #1885AD;text-align: center;cursor: pointer"
                    @click="changePassword">Save Changes</div>
                  <div style="padding: 10px;color: #1890A9;text-align: center;cursor: pointer" @click="discardChanges">
                    Cancel</div>
                </div>
              </div>
            </div>
          </div>
          <div class="__section-right"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderTwo from "../components/Partials/HeaderTwo";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
export default {
  name: "ProfileEdit",
  components: {
    HeaderTwo,
    VueSlider,
    Datepicker,
  },
  computed: {
    ...mapGetters(["getMeProfile", "getCountries", "getCities"]),
    isAvailable() {
      return this.getMeProfile.profile.availability > 50;
    },
    location() {
      if (this.getMeProfile.profile.location_id === null)
        return {
          country: {},
          city: {},
          address: "",
        };
      else
        return {
          country: this.getMeProfile.profile.location.country_id,
          city: this.getMeProfile.profile.location.city_id,
          address: this.getMeProfile.profile.location.address,
        };
    },
  },
  data() {
    return {
      availability_value: 0,
      colorCache: {},
      oldPassword: "",
      newPassword: "",
      newPassword2: "",
      options: {
        dotSize: 14,
        width: "70%",
        height: 5,
        railStyle: {
          backgroundColor: "#707070",
        },
        processStyle: {
          backgroundColor: "#707070",
        },
      },
      infoCollapsed: true,
      passwordCollapsed: false,
      meProfileData: null,

      items: ["Foo", "Bar", "Fizz", "Buzz"],
    };
  },
  mounted() {
    this.$store.dispatch("GET_COUNTRIES");
    this.$store.dispatch("GET_ME_PROFILE_DATA");
  },
  methods: {
    uploadPhoto() {
      this.$refs.photo.click();
    },
    loadCities(e) {
      this.$store.dispatch("GET_CITIES", { country: e.target.value });
    },

    saveChanges() {
      let data = {
        first_name: this.getMeProfile.user.first_name,
        last_name: this.getMeProfile.user.last_name,
        email: this.getMeProfile.user.email,
        availability: this.getMeProfile.profile.availability,
        available_from: new Date(this.getMeProfile.profile.available_from)
          .toISOString()
          .slice(0, 10),
        available_until: new Date(this.getMeProfile.profile.available_until)
          .toISOString()
          .slice(0, 10),
        willing_to_work: this.getMeProfile.profile.willing_to_work,
        phone: this.getMeProfile.profile.phone,
        location:
          this.location.country +
          "," +
          this.location.city +
          "," +
          this.location.address,
        description: this.getMeProfile.profile.description,
      };
      console.log(data);
      this.$store.dispatch("EDIT_PROFILE_INFO", data);
    },

    changePassword() {
      let data = {
        new_password: this.newPassword,
        old_password: this.oldPassword,
      };
      if (this.newPassword2 === this.newPassword)
        this.$store.dispatch("CHANGE_PASSWORD", data);
      else alert("Your passwords don't match");
    },

    discardChanges() {
      this.$router.push({ name: "consultant-profile" });
    },
  },
};
</script>

<style lang="scss" scoped>
.__wrapper {
  display: flex;
  background: #f2f2f2 !important;
  min-height: 100%;
  flex-direction: column;

  .__head {
    height: 90px;
    margin-top: 30px;
    background: url("../assets/images/backgrounds/header_bg.svg");
  }

  .__body {
    background: #f2f2f2;
    height: 100%;

    .__container {
      margin: 0 auto;
      width: 80%;

      .__content {
        position: relative;
        display: grid;
        grid-template-columns: 2fr 0.5fr;
        grid-column-gap: 20px;

        .__section-right {}

        .__section-left {
          position: relative;

          .__section-1 {
            position: relative;
            padding-bottom: 50px;
            background: #fff;
            padding-left: 20px;
            border-radius: 5px;
            box-shadow: 0 6px 6px rgba(0, 0, 0, 0.16);
            border-bottom: 1px solid rgba(112, 112, 112, 0.4);
            margin-bottom: 10px;

            img {
              width: 100px;
              height: 100px;
              border-radius: 100px;
              background: white;
              padding: 7px;
              position: absolute;
              border: 1px solid #fff;
              top: -40px;
              left: 20px;
            }

            span {
              margin-left: 18%;
              position: relative;
              top: 20px;
              font-size: 20px;
              font-weight: normal;
            }
          }

          .__section-2 {
            margin-top: 20px;

            label {
              color: #707070;
              font-size: 20px;
            }

            .__rows {
              .__row {
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-column-gap: 20px;
                margin-top: 10px;
                grid-row-gap: 10px;
                margin-bottom: 20px;

                span {
                  margin-left: 10px;
                  font-size: 12px;
                }
              }

              .__row-3 {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-column-gap: 20px;
                margin-top: 10px;
                grid-row-gap: 10px;
                margin-bottom: 20px;

                span {
                  font-size: 12px;
                  margin-left: 10px;
                }
              }

              .__row-1 {
                display: grid;
                grid-template-columns: 1fr;
                grid-column-gap: 20px;
                margin-top: 10px;
                grid-row-gap: 10px;
                margin-bottom: 20px;

                span {
                  font-size: 12px;
                  margin-left: 10px;
                }

                textarea {
                  resize: none;
                  height: 150px !important;
                }
              }
            }
          }
        }
      }
    }
  }
}

.__colored {
  color: #1890a9;
}

.__green {
  color: #1ba5a4;
}

.__white {
  color: #ffffff;
}

.__v-space {
  margin-top: 15px !important;
}

.error {
  border: 1px solid maroon !important;
}

.__inp-text {
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.16);
  outline: none;
  color: #707070 !important;
}

.__card {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.16);
}
</style>
